<!-- 
*****************************************************************************
**                                                                         **
** Copyright (c) 2012-2024, Tyker Technology BV                            **
** All rights reserved.                                                    **
**                                                                         **
** This software is the confidential and proprietary information of        **
** Tyker Technology BV. Unauthorized copying or disclosure of this file,   **
** via any medium is strictly prohibited. This file is only available to   **
** authorized individuals with the permission of the copyright holders.    **
** If you encounter this file and do not have permission, please contact   ** 
** the copyright holders and delete this file.                             **
**                                                                         **
***************************************************************************** 
-->

<template>
  <v-app>
    <v-card>
      <v-card-title>{{ language.t('ChangePassword.changePassword') }}</v-card-title>
      <v-container>
        <v-alert v-if="errorMessage" type="error">{{ errorMessage }}</v-alert>
        <v-form ref="form">
          <v-text-field v-model="match" :type="'password'"
            :label="language.t('ChangePassword.newPassword')"></v-text-field>

          <v-text-field v-model="model" :rules="rules" :type="'password'"
            :label="language.t('ChangePassword.repeatPassword')"></v-text-field>

          <v-btn @click="save">{{ language.t('App.save') }}</v-btn>
        </v-form>
      </v-container>
    </v-card>
  </v-app>
</template>

<script>


export default {
  name: "resetPassword",
  components: {
  },
  props: {},
  data: () => ({
    match: '',
    model: '',
    rules: [],
    errorMessage: null,
    email: '',
    token: ''
  }),
  computed: {
  },
  mounted: function () {
    this.rules = [v => v.length >= 8 || this.language.t('FormRules.passwordLength'),
    v => (!!v && v) === this.match ||
      this.language.t('FormRules.passwordValidation')
    ]
    var variables = window.location.pathname.split('/');
    this.verifyPasswToken(variables[2], variables[3]);
  },
  methods: {
    verifyPasswToken(email, token) {
      this.$axios.get(route('api.createPassword', [email, token])).then((res) => {
        this.email = email;
        this.token = token;
      })
        .catch((error) => {
          this.errorMessage = this.language.t('ChangePassword.' + error.response.data.reason);
        });
    },
    validateField() {
      this.$refs.form.validate();
    },
    save() {

      //required data
      let data = new FormData();
      data.set('password', this.model);
      this.$axios.post(route('api.storePassword', [this.email, this.token]), data, { headers: { 'Content-Type': 'multipart/form-data' } }).then((res) => {
        var fileLink = document.createElement("a");
        fileLink.href = '/';
        fileLink.click();
      }).catch((error) => {
        this.errorMessage = this.language.t('ChangePassword.' + error.response.data.reason);
      });
    }
  },
  watch: {
    match: 'validateField',
    model: 'validateField',
  }
};
</script>

<style>
#main {
  height: 100%;
}

#alerts {
  left: 0;
  right: 0;
  margin: auto;
  width: 80%;
}

.v-application--wrap {
  /* fix proper height for android */
  min-height: 0vh !important;
}
</style>